<template>
  <div class="class-of-term md-layout" @click="toggleTable" v-if="isToggle">
    <span class="md-layout-item md-size-30"> {{ classData.name }}</span>
    <span class="md-layout-item md-size-10 text-[#08980E] font-medium"
      >P: {{ classData.present }}</span
    >
    <span class="md-layout-item md-size-10 text-[#964AA0] font-medium"
      >EA: {{ classData.ex_absence }}</span
    >
    <span class="md-layout-item md-size-10 text-[#2D82B5] font-medium"
      >ET: {{ classData.ex_tardy }}</span
    >
    <span class="md-layout-item md-size-10 text-[#D6030C] font-medium"
      >UA: {{ classData.unex_absence }}</span
    >
    <span class="md-layout-item md-size-10 text-[#D3660A] font-medium"
      >UT: {{ classData.unex_tardy }}</span
    >
    <span class="triangle-down"></span>
  </div>
  <div v-else class="md-layout class-detail" @click="toggleTable">
    <div class="header-class md-layout-item md-size-100">
      <span class="md-layout-item md-size-30"> {{ classData.name }}</span>
      <span class="md-layout-item md-size-10 text-[#08980E] font-medium"
        >P: {{ classData.present }}</span
      >
      <span class="md-layout-item md-size-10 text-[#964AA0] font-medium"
        >EA: {{ classData.ex_absence }}</span
      >
      <span class="md-layout-item md-size-10 text-[#2D82B5] font-medium"
        >ET: {{ classData.ex_tardy }}</span
      >
      <span class="md-layout-item md-size-10 text-[#D6030C] font-medium"
        >UA: {{ classData.unex_absence }}</span
      >
      <span class="md-layout-item md-size-10 text-[#D3660A] font-medium"
        >UT: {{ classData.unex_tardy }}</span
      >
      <span class="triangle-up"></span>
    </div>
    <div class="md-layout-item md-size-100 pl-7">
      <md-table>
        <md-table-row>
          <md-table-head
            ><span class="font-medium">{{
              $t("common.date")
            }}</span></md-table-head
          >
          <md-table-head
            ><span class="font-medium">{{
              $t("common.status")
            }}</span></md-table-head
          >
          <md-table-head
            ><span class="font-medium">{{
              $t("progress_report.comment")
            }}</span></md-table-head
          >
          <md-table-head
            ><span class="font-medium">{{
              $t("student.class_comment")
            }}</span></md-table-head
          >
        </md-table-row>
        <md-table-row
          v-for="(item, index) in classData.attendances"
          :key="'attend' + index"
        >
          <md-table-cell>
            <p class="inline-block w-max">
              {{
                convertTimeByTimezone(
                  item.date,
                  "Etc/UTC",
                  userTz || "Etc/UTC",

                  formatDateClient
                )
              }}
            </p></md-table-cell
          >
          <md-table-cell
            ><p class="inline-block w-max">
              {{ generateStatus(item.status) }}
            </p></md-table-cell
          >
          <md-table-cell
            ><p class="whitespace-pre-line leading-6">
              {{ item.description }}
            </p></md-table-cell
          >
          <md-table-cell
            ><p class="whitespace-pre-line leading-6">
              {{ item.calendar ? item.calendar.zoom_meeting_comment : "" }}
            </p></md-table-cell
          >
        </md-table-row>
      </md-table>
    </div>
  </div>
</template>
<script>
import {
  formatDateClient,
  convertTimeByTimezone
} from "@/helpers/datetime-helper";
import { generateStatus } from "@/helpers/text-helper";
import { mapGetters } from "vuex";

export default {
  props: ["classData"],
  data() {
    return {
      isToggle: true,
      formatDateClient,
      generateStatus,
      convertTimeByTimezone
    };
  },
  computed: {
    ...mapGetters("user", {
      userTz: "timezone"
    })
  },
  methods: {
    toggleTable() {
      this.isToggle = !this.isToggle;
    }
  }
};
</script>
<style lang="scss" scoped>
* {
  font-size: 14px;
}
.class-of-term {
  width: calc(100% - 10px);
  border-radius: 50px;
  padding: 10px 20px;
  margin: 10px;
  cursor: pointer;
  background-color: #dee2e6;
  display: flex;
  border: 2px solid #ccc;
  align-items: center;
  justify-content: space-between;
  text-transform: capitalize;
  .triangle-down {
    width: 0;
    height: 0;
    border-left: 7px solid transparent;
    border-right: 7px solid transparent;
    border-top: 14px solid #555;
  }
}
.class-detail {
  width: calc(100% - 10px);
  border: 1px solid #ccc;
  border-radius: 10px 10px 0 0;
  margin: 10px;
  .header-class {
    display: flex;
    cursor: pointer;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #ccc;
    background: #fff;
    padding: 10px 20px;
    border-radius: 50px 50px 0 0;
  }
  .triangle-up {
    width: 0;
    height: 0;
    border-left: 7px solid transparent;
    border-right: 7px solid transparent;
    border-bottom: 14px solid #555;
  }
}
</style>
